export class PageQuery {
  size: number;
  page: number;
  sort: string[];
  request_sort: string[];
}
